import {SlackIntegration} from '../../SlackIntegration/utils';
import {NotificationTriggeredAction, Trigger} from './TriggersTable/utilTypes';

export type NotificationConfig = {
  teamSlackIntegration?: SlackIntegration;
};

// This is used when we have an already created trigger in the UI
export const getNotificationConfig = (
  trigger: Trigger
): NotificationConfig & {entityName?: string} => {
  const emptyConfig: NotificationConfig = {
    teamSlackIntegration: undefined,
  };

  const triggerAction = trigger.triggeredAction;
  if (
    triggerAction?.actionType !== 'NotificationTriggeredAction' ||
    !triggerAction.actionConfig
  ) {
    return emptyConfig;
  }
  const notificationConfig =
    triggerAction.actionConfig as NotificationTriggeredAction;

  return {
    teamSlackIntegration: {
      id: notificationConfig.integrationID,
      // to pull these we'd need to fetch the integration, they are not used right now
      // TODO: are we sure they're not used? :)
      teamName: '',
      channelName: notificationConfig.channelName,
    },
    entityName: notificationConfig.entityName,
  };
};
